import '@/main.css'
import './index.css'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { ErrorBoundary, FirebaseAuthGuard } from '@playground/components'
import { queryClient } from '@playground/features/query/queryClient'
import { theme } from '@playground/theme'
import { QueryClientProvider } from '@tanstack/react-query'
import { initFirebase } from '@zealth/core/firebase/runtime'
import React from 'react'
import ReactDOM from 'react-dom/client'

import firebaseConfig from '@/config/firebase'
import { initSentry } from '@/config/sentry'

import AppRouter from './AppRouter'

initSentry('playground')
initFirebase(firebaseConfig)

// The guard sits inside the providers, not around them: the sign-in forms use
// react-query mutations, and the sign-in screen should be themed like the rest.
const Root = () => (
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <FirebaseAuthGuard>
          <AppRouter />
        </FirebaseAuthGuard>
      </QueryClientProvider>
    </ThemeProvider>
  </ErrorBoundary>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  import.meta.env.VITE_REACT_STRICT_MODE === 'true' ? (
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  ) : (
    <Root />
  )
)
